type Point = [number, number];

export type TrackFrameOverlayBox = {
  left: number;
  top: number;
  width: number;
  height: number;
};

export const TRACK_FRAME_OVERLAY_BOX_STYLE = {
  border: "1px solid #FF00FF",
  backgroundColor: "transparent",
  boxShadow: "0 0 0 9999px rgba(0, 0, 0, 0.4)",
} as const;

export const getTrackFrameOverlayBox = (
  points: Point[],
): TrackFrameOverlayBox | null => {
  if (points.length === 0) {
    return null;
  }

  const xs = points.map(([x]) => x * 100);
  const ys = points.map(([, y]) => y * 100);
  const left = Math.min(...xs);
  const right = Math.max(...xs);
  const top = Math.min(...ys);
  const bottom = Math.max(...ys);

  return {
    left,
    top,
    width: right - left,
    height: bottom - top,
  };
};
